import React from 'react';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Pricing Plan Price Component
 * -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal css classes
 * -------------------------- NATIVE PROPERTIES -------------------------------
 * @param height {number} Additionnal height of component
 * @param alignItems {'flex-start' | 'flex-end' | 'center'}
 * @param children {React.ReactNode} Children
 */
const PricingPlanPrice = ({ className, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('plan-price', className));
    return React.createElement("div", { className: classes, ...others });
};
export default PricingPlanPrice;
//# sourceMappingURL=PricingPlanPrice.js.map